import React from 'react';

import styles from './styles/database-type.module.css';

import TypeBox from './common/TypeBox';

export default function DatabaseType({ setCurrentStepName, changeConnectionInfo }) {
    const dbTypeMap = ['MARIADB', 'MYSQL', 'MSSQL', 'POSTGRESQL', 'ORACLE', 'SQLITE'];

    return (
        <div className={styles.wrapper} data-type={dbTypeMap.length > 12 && 'over'}>
            {dbTypeMap.map((dbType, index) =>
                <TypeBox
                    key={index}
                    step='type'
                    dbType={dbType}
                    setCurrentStepName={setCurrentStepName}
                    changeConnectionInfo={changeConnectionInfo}
                />
            )}
        </div>
    );
}
